<tt-field-container class="col-xs-12 sp-0 tt-orderhead__dialog">
    <tt-comment
        *ngFor="let comment of dialog; trackBy: trackBy"
        [ttAuthor]="comment.registered_by_name"
        [ttDatetime]="comment.reg_datetime"
        [ttComment]="comment.messagetext"
        [ttIsCurrentUser]="comment.mymessage === '1'"
    ></tt-comment>
</tt-field-container>

<tt-button ttText="tt_dialog" (ttClick)="openDialogDialog()" ttType="secondary"></tt-button>
